import { useLang } from '../lang'
import type { Tab } from '../types'
import * as s from './shell.css'

// The place and the name are the instance's own — from config via the bootstrap. Sources & credits
// is reachable here (brief §3.2) — routable, just quieter than the nav. About is kept here too even
// though it is back in the masthead: a second, calmer way in costs nothing, and old links hold.
export function Footer({
  place,
  siteName,
  techPage,
  onNav,
}: {
  techPage: boolean
  place: { en: string; ga: string; coords: string | null } | null
  siteName: string
  onNav: (tab: Tab) => void
}) {
  const { t, lang } = useLang()
  const here = place ? (lang === 'ga' ? place.ga : place.en) : null
  return (
    <footer className={s.foot}>
      <span>{t(`${siteName} · Listening Station`, `${siteName} · Stáisiún Éisteachta`)}</span>
      {/* The separator belongs to the phrase it introduces, not to the row: as its own flex
          child it was left stranded at the end of a wrapped line on a phone, and hiding it by
          breakpoint then dropped it on the widths where the row still ran on. */}
      {here && (
        <span>
          <span className={s.footDot} aria-hidden="true">
            ·{' '}
          </span>
          {here}
          {place?.coords && <span className={s.footCoords}> · {place.coords}</span>}
        </span>
      )}
      <span className={s.footLinks}>
        <button className={s.footLink} onClick={() => onNav('about')}>
          {t('About', 'Fúinn')}
        </button>
        <button className={s.footLink} onClick={() => onNav('sources')}>
          {t('Sources & credits', 'Foinsí')}
        </button>
        {techPage && (
          <button className={s.footLink} onClick={() => onNav('tech')}>
            {t('Tech & hardware', 'Teicneolaíocht')}
          </button>
        )}
        <button className={s.footLink} onClick={() => onNav('letter')}>
          {t('The daily letter', 'An litir laethúil')}
        </button>
        {/* The footer is where a reader looks for this, and where mailbox providers and every
            email footer we send point. It stays a real /privacy URL, not a ?tab=. */}
        <button className={s.footLink} onClick={() => onNav('privacy')}>
          {t('Privacy', 'Príobháideacht')}
        </button>
      </span>
    </footer>
  )
}
